export default {
    Default: [  // 默认服装
        "GAssets/AsiaFemale/head/basemodelafemale_head.bundle",
        "GAssets/AsiaFemale/brow/brow000.bundle",
        "GAssets/AsiaFemale/cloth/lower_inner/shorts/shorts001.bundle",
        "GAssets/AsiaFemale/cloth/upper_inner/shirt/shirt002.bundle"
    ]
}